<script setup lang="ts">
import { UserRound } from "lucide-vue-next";
const nextHostname = new URL(window.queryParams.next).hostname.replace(/^www\./, '') || 'your account';
</script>

<template>
	<header class="my-10 flex flex-col items-center gap-3 text-center max-w-md mx-auto">

		<h1 class="text-3xl font-bold tracking-tight flex items-center gap-4 line-clamp-1 truncate max-w-full">
			<div
				 class="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-primary/20 to-primary/5 shadow-sm ring-1 ring-primary/15">
				<UserRound class="h-7 w-7 text-primary" />
			</div>
			<div>
				<!-- <span class="text-primary">My</span><span class="text-foreground">Order</span><span
					  class="text-primary">ID</span> -->
				{{ nextHostname }}
			</div>
		</h1>

		<!-- <div
			 class="flex max-w-sm flex-col items-center gap-0.5 rounded-2xl border border-primary/10 bg-primary/5 px-4 py-2 text-center">
			<p class="flex items-center justify-center gap-1.5 text-xs font-medium leading-snug text-foreground">
				one click local shopping
			</p>
		</div> -->
		<!-- <p class="text-[11px] leading-snug text-muted-foreground"> -->
		<!-- one login to rule them all<br>🧙‍♂️👑📯🧝‍♂️🧔‍♂️🧑‍🌾🧑‍🌾🧑‍🌾🧑‍🌾 -->
		<!-- no typing every time you shop -->
		<!-- </p> -->
	</header>
</template>
